import { render, staticRenderFns } from "./AccountResult.vue?vue&type=template&id=4438d558&scoped=true&"
import script from "./AccountResult.vue?vue&type=script&lang=js&"
export * from "./AccountResult.vue?vue&type=script&lang=js&"
import style0 from "./AccountResult.vue?vue&type=style&index=0&id=4438d558&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4438d558",
  null
  
)

export default component.exports